// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"feb6ff2b","272":"9480e337","348":"7f58f32f","407":"e9e63683","480":"3500c0cd","618":"13c61a70"}[chunkId] + ".chunk.css";
};